import { QuoteEmailAttachment } from "./email-attachment.model";

export class QuoteClientEmailDetails {
  constructor(
    private clientEmail: string = null,
    private clientSubject: string = null,
    private clientBody: string = null,
    private salesEmail: string = null,
    private attachments: QuoteEmailAttachment[] = [],
  ) {}

  public getClientEmail(): string {
    return this.clientEmail;
  }

  public getClientSubject(): string {
    return this.clientSubject;
  }

  public getClientBody(): string {
    return this.clientBody;
  }

  public getSalesEmail(): string {
    return this.salesEmail;
  }

  public getAttachments(): QuoteEmailAttachment[] {
    return this.attachments;
  }

  public hasAttachments(): boolean {
    return this.attachments.length > 0;
  }
}
